import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_CLIENT_CREATE, PATH_CLIENT_INFO } from "@configs";
import { ClientForm } from "@modules";
import { useClientDetail } from "@utils";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

export const PageCreateClient = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { data: client } = useClientDetail(id, "standard");

  const data = [
    {
      title: <a href={PATH_CLIENT_INFO || ""}>{t("page.client_information")}</a>,
    },
    {
      title: <a href={PATH_CLIENT_CREATE || ""}>{t("page.add_client")}</a>,
    },
  ];

  return (
    <>
      <ComponentHeader title={t("page.add_client")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <ClientForm client={client} />
      </StyledCreate>
    </>
  );
};
